const safeRedirect = (url: string): void => {
  const parsedUrl = new URL(url, window.location.origin);

  if (parsedUrl.origin !== window.location.origin) {
    throw new Error(`Unsafe redirect blocked: ${url}`);
  }

  const safePath = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
  window.location.assign(safePath);
};

export default safeRedirect;
